import {
  ACTION, FailAxes, FailCaseTypes, FailCells, FailDetails,
  FailRiskAreas,
  FailSaveCells,
  ReceiveAxes,
  ReceiveCaseTypes,
  ReceiveCells, ReceiveDetails,
  ReceiveRiskAreas,
  ReceiveSaveCells,
  RequestAxes,
  RequestCaseTypes,
  RequestCells, RequestDetails,
  RequestRiskAreas,
  RequestSaveCells,
  SelectCell,
  SetPreviousType,
  SetThirdAxisItem,
  SetType,
  UpdateModifiedCells
} from 'app/area/risk-matrix-administration/action-types';
import { RiskMatrixState } from 'app/area/risk-matrix-administration/types-store';
import { withOptionsReducer } from 'app/components/options-handler';
import { STATE } from 'app/constants';
import { Action, AnyAction, Reducer } from 'redux';

export const INITIAL_ITEM_STATE: RiskMatrixState = {
  type: undefined,
  previousType: undefined,
  selectedCellId: undefined,
  axes: undefined,
  cells: [],
  thirdAxisItem: undefined,
  modifiedCells: [],
  details: undefined,
  riskAreas: [],
  caseTypes: [],
  savingCells: false,
  fetchingAxes: false,
  fetchingCells: false,
  fetchingDetails: false,
  fetchingRiskAreas: false,
  fetchingCaseTypes: false
};

const riskMatrixReducers: { [indexer: string]: Reducer<RiskMatrixState, Action> } = {

  [ACTION.SET_TYPE]: (state: RiskMatrixState, action: SetType): RiskMatrixState => {
    return {
      ...state,
      type: action.riskMatrixType,
      modifiedCells: [],
      previousType: state.type ?? state.previousType
    };
  },

  [ACTION.SET_PREVIOUS_TYPE]: (state: RiskMatrixState, action: SetPreviousType): RiskMatrixState => {
    return {
      ...state,
      previousType: action.riskMatrixType
    };
  },

  [ACTION.SET_THIRD_AXIS_ITEM]: (state: RiskMatrixState, action: SetThirdAxisItem): RiskMatrixState => {
    return {
      ...state,
      thirdAxisItem: action.thirdAxisItem
    };
  },

  [ACTION.SELECT_CELL]: (state: RiskMatrixState, action: SelectCell): RiskMatrixState => {
    return {
      ...state,
      selectedCellId: action.selectedCellId
    };
  },

  [ACTION.UPDATE_MODIFIED_CELLS]: (state: RiskMatrixState, action: UpdateModifiedCells): RiskMatrixState => {
    return {
      ...state,
      modifiedCells: action.modifiedCells
    };
  },

  [ACTION.REQUEST_DETAILS]: (state: RiskMatrixState, action: RequestDetails): RiskMatrixState => {
    return {
      ...state,
      fetchingDetails: true
    };
  },

  [ACTION.RECEIVE_DETAILS]: (state: RiskMatrixState, action: ReceiveDetails): RiskMatrixState => {
    return {
      ...state,
      fetchingDetails: false,
      details: action.details
    };
  },

  [ACTION.FAIL_DETAILS]: (state: RiskMatrixState, action: FailDetails): RiskMatrixState => {
    return {
      ...state,
      fetchingDetails: false
    };
  },

  [ACTION.REQUEST_CASE_TYPES]: (state: RiskMatrixState, action: RequestCaseTypes): RiskMatrixState => {
    return {
      ...state,
      fetchingCaseTypes: true
    };
  },

  [ACTION.RECEIVE_CASE_TYPES]: (state: RiskMatrixState, action: ReceiveCaseTypes): RiskMatrixState => {
    return {
      ...state,
      fetchingCaseTypes: false,
      caseTypes: action.caseTypes
    };
  },

  [ACTION.FAIL_CASE_TYPES]: (state: RiskMatrixState, action: FailCaseTypes): RiskMatrixState => {
    return {
      ...state,
      fetchingCaseTypes: false
    };
  },

  [ACTION.REQUEST_AXES]: (state: RiskMatrixState, action: RequestAxes): RiskMatrixState => {
    return {
      ...state,
      fetchingAxes: true
    };
  },

  [ACTION.RECEIVE_AXES]: (state: RiskMatrixState, action: ReceiveAxes): RiskMatrixState => {
    return {
      ...state,
      fetchingAxes: false,
      axes: action.axes
    };
  },

  [ACTION.FAIL_AXES]: (state: RiskMatrixState, action: FailAxes): RiskMatrixState => {
    return {
      ...state,
      fetchingAxes: false
    };
  },
  [ACTION.REQUEST_CELLS]: (state: RiskMatrixState, action: RequestCells): RiskMatrixState => {
    return {
      ...state,
      fetchingCells: true
    };
  },

  [ACTION.RECEIVE_CELLS]: (state: RiskMatrixState, action: ReceiveCells): RiskMatrixState => {
    return {
      ...state,
      fetchingCells: false,
      cells: action.cells
    };
  },

  [ACTION.FAIL_CELLS]: (state: RiskMatrixState, action: FailCells): RiskMatrixState => {
    return {
      ...state,
      fetchingCells: false
    };
  },

  [ACTION.REQUEST_RISK_AREAS]: (state: RiskMatrixState, action: RequestRiskAreas): RiskMatrixState => {
    return {
      ...state,
      fetchingRiskAreas: true
    };
  },

  [ACTION.RECEIVE_RISK_AREAS]: (state: RiskMatrixState, action: ReceiveRiskAreas): RiskMatrixState => {
    return {
      ...state,
      fetchingRiskAreas: false,
      riskAreas: action.riskAreas
    };
  },

  [ACTION.FAIL_RISK_AREAS]: (state: RiskMatrixState, action: FailRiskAreas): RiskMatrixState => {
    return {
      ...state,
      fetchingRiskAreas: false
    };
  },

  [ACTION.REQUEST_SAVE_CELLS]: (state: RiskMatrixState, action: RequestSaveCells): RiskMatrixState => {
    return {
      ...state,
      savingCells: true
    };
  },

  [ACTION.RECEIVE_SAVE_CELLS]: (state: RiskMatrixState, action: ReceiveSaveCells): RiskMatrixState => {
    return {
      ...state,
      savingCells: false
    };
  },

  [ACTION.FAIL_SAVE_CELLS]: (state: RiskMatrixState, action: FailSaveCells): RiskMatrixState => {
    return {
      ...state,
      savingCells: false
    };
  },

  [ACTION.CLEAR_ALL_DATA]: (state: RiskMatrixState, action: FailSaveCells): RiskMatrixState => {
    return {
      ...state,
      ...INITIAL_ITEM_STATE
    };
  }
};

export const riskMatrixReducer: Reducer<RiskMatrixState> =
  (state: RiskMatrixState = INITIAL_ITEM_STATE, action: AnyAction) => {
    const r = riskMatrixReducers[action.type];
    return (r && r(state, action)) || state;
  };

export const reducer = withOptionsReducer(STATE.riskMatrix, riskMatrixReducer);
